let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7ro25")).then(() => parcelRequire('f3wt8'));